import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  GAME_HISTORY_DETAILS_FEATURE_KEY,
  gameHistoryDetailState,
} from './game-history-details.reducer';

// Lookup the 'GameHistoryDetails' feature state managed by NgRx
export const getGameHistoryDetailsState =
  createFeatureSelector<gameHistoryDetailState>(
    GAME_HISTORY_DETAILS_FEATURE_KEY,
  );

export const getGameHistoryDetailsLoaded = createSelector(
  getGameHistoryDetailsState,
  (state: gameHistoryDetailState) => state.loaded,
);

export const getGameHistoryDetailsError = createSelector(
  getGameHistoryDetailsState,
  (state: gameHistoryDetailState) => state.error,
);

export const getGameHistoryDetails = createSelector(
  getGameHistoryDetailsState,
  (state: gameHistoryDetailState) => state.matchResultsForUser,
);

export const getGameHistoryDetailsTotal = createSelector(
  getGameHistoryDetailsState,
  (state: gameHistoryDetailState) => state.total,
);
